export default "__VITE_ASSET__DbK9Ag$K__"